import api from '@http/api';
import moment from 'moment';
import { IPerfil } from '@interfaces/UserComplete';



export interface ITipoCorrespondencia {
  id: string;
  descricao: string;
  data_cadastro: string;
  status_ativo: boolean;
}




class PageEditTriagemPerfilServices {

    public async ValidarTriagemCorrespondencia(id_perfil: any, informacaoInstantanea: boolean, nova_informacao: any, coluna: string) {
    return await api
    .post(`/api/Triagem/AtualizarNovaInformacao?id_perfil=${id_perfil}&informacaoInstantanea=${informacaoInstantanea}&nova_informacao=${nova_informacao}&coluna=${coluna}`,)
    .then(response => {
      return {
        error: false,
        //response: response.data,
      };
    })
    .catch(error => {
      return {
        error: true,
        //response: [],
      };
    });
  }

  public async DescartarTriagemCorrespondencia(id_perfil: any, coluna: string) {
    return await api
    .delete(`/api/Triagem/DescartarNovaInformacao?id_perfil=${id_perfil}&coluna=${coluna}`,)
    .then(response => {
      return {
        error: false,
        //response: response.data,
      };
    })
    .catch(error => {
      return {
        error: true,
        //response: [],
      };
    });
  }



  public async loadCorrespondenciaById(id: string) {
    return await api
      .get(
        `/api/TipoCorrespondencia/GetTipoCorrespondenciaById/${id}`,
      )
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }

  public async loadTiposCorrespondecia() {
    return await api
      .get<ITipoCorrespondencia[]>(
        '/api/TipoCorrespondencia/GetTiposCorrespondecia',
      )
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }


}

export default PageEditTriagemPerfilServices;
